import { createAsyncThunk } from "@reduxjs/toolkit";
import companyApi from "@infrastructure/company-api";
import { getErrorPayload } from "@application/helpers/api-helper";
export const fetchCompaniesAsync = createAsyncThunk("companies/fetchPaginated", async (query, { rejectWithValue }) => {
    try {
        const response = await companyApi.getCompanies(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const fetchAllCompaniesAsync = createAsyncThunk("companies/fetchAll", async (_, { rejectWithValue }) => {
    try {
        const response = await companyApi.getAll();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data || "Failed to fetch companies");
    }
});
export const createCompanyAsync = createAsyncThunk('companies/createCompany', async (company, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await companyApi.createCompany(company);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateCompanyAsync = createAsyncThunk('companies/updateCompany', async (company, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await companyApi.updateCompany(company);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getAllByUserAsync = createAsyncThunk("companies/getAllByUser", async (_, { rejectWithValue }) => {
    try {
        const response = await companyApi.getAllByUser();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateStatusAsync = createAsyncThunk("companies/updateStatus", async (command, { rejectWithValue }) => {
    try {
        await companyApi.updateStatus(command);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCompanyByIdAsync = createAsyncThunk("companies/getById", async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await companyApi.getById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
